import { PAGE } from '../../constants/url';


export const tableColumnsDefined = {
  userList: {
    key: 'userList',
    page: PAGE.wishitem.id,
    defaultSort: 'line_uuid',
    search: ['id'],
    tableHeader: [
      {
        id: 'messaging_status_ai_blocked',
        name: '啟用AI',
        type: 'dimension',
        sort: true,
        align: 'center',
        width: '64px',
        tooltip: null,
        render: {
          method: 'aiBlocked',
          related: {
            id: 'messaging_status_ai_blocked'
          }
        },
        icon: null
      },
      {
        id: 'line_uuid',
        name: 'UID',
        type: 'dimension',
        sort: true,
        align: 'left',
        width: '280px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'name',
        name: '姓名',
        type: 'dimension',
        sort: true,
        align: 'left',
        width: '150px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'email',
        name: 'Email',
        type: 'dimension',
        sort: true,
        align: 'left',
        width: '180px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'phone',
        name: '電話',
        type: 'dimension',
        sort: true,
        align: 'center',
        width: '150px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'questions',
        name: '提問數',
        type: 'dimension',
        sort: true,
        align: 'center',
        width: '80px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'wished',
        name: '願望清單商品數',
        type: 'dimension',
        sort: true,
        align: 'center',
        width: '80px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'wished_items',
        name: '願望清單',
        type: 'dimension',
        sort: false,
        align: 'left',
        width: '480px',
        tooltip: null,
        render: {
          method: 'wishedItems',
          related: {
            id: 'wished_items'
          }
        },
        icon: null
      },
    ]
  },
  productList: {
    key: 'productList',
    page: PAGE.productList.id,
    defaultSort: 'product_title',
    search: ['id'],
    tableHeader: [
      {
        id: 'product_select',
        name: '選取',
        type: 'dimension',
        sort: false,
        align: 'center',
        width: '64px',
        tooltip: null,
        render: {
          method: 'productSelect',
        },
        icon: null
      },
      {
        id: 'product_title',
        name: '商品標題',
        type: 'dimension',
        sort: false,
        align: 'left',
        width: '380px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'user_question_counts',
        name: '消費者問答次數',
        type: 'dimension',
        sort: false,
        align: 'center',
        width: '140px',
        tooltip: null,
        render: null,
        icon: null
      },
      {
        id: 'user_question_summary',
        name: '消費者問答摘要',
        type: 'dimension',
        sort: false,
        align: 'left',
        width: '600px',
        tooltip: null,
        render: {
          method: 'userQuestionSummary',
          related: {
            id: 'user_question_summary'
          }
        },
        icon: null
      },
    ]
  }
}